import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";
import { SessionEnded } from "src/store/data/user/actionsUser";
import axios from "src/utils/axios";

/**
 * A read for a catalogue screen that fails quietly.
 *
 * PostFunction toasts the raw axios message on any error ("Request failed
 * with status code 502"). For a list that is about to show its own error
 * state with a Retry button, that toast is noise in words staff can't act
 * on. Same request, same token, same logout on an expired session; it just
 * leaves the explaining to the screen. Resolves to the response body, or
 * false when the request failed.
 */
export async function quietPost({ route, data = {}, dispatch }) {
  try {
    const token = getLocalStorage(dataLocalStorage.userinfo)?.token ?? "";
    const res = await axios({
      method: "post",
      url: route,
      data,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res?.data ?? false;
  } catch (err) {
    if (err?.response?.status === 401 && dispatch) dispatch(SessionEnded());
    return false;
  }
}
